export const SelectedEleMgrType = {
    SLIDE: 'SelectedEleMgrType_SLIDE',
    GROUP: 'SelectedEleMgrType_GROUP',
    SMART_ART: 'SelectedEleMgrType_SMART_ART',
};
